<template>
  <div class="d-flex align-center">
    <span>
      <v-icon color="grey">mdi-alpha-l-box</v-icon>
      <span class="text-subtitle-2">language:</span>
    </span>
    <v-btn-toggle
      v-model="$store.state.lang"
      tile
      mandatory
      color="blue darken-4"
      @change="setlang"
      group>
      <v-btn v-for="i in langs" :key="i.id" :value="i.flag">
        {{i.type}}
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  name: 'Language',
  data(){
    return{
      language_io_api:'language/io/',
      langs:[],
    }
  },
  computed:{
    langset(){
      return this.$store.state.lang;
    },
  },
  methods:{
    setlang(v){
      this.$store.commit('set_lang',v);
      Cookies.set('lang',v,{ expires: 7 })
    },
    fetch(){
      let postdata = {};
      this.$axios.post(this.$store.state.baseurl + this.language_io_api,postdata)
          .then(
            response => {
              if(response.data.err == '0'){
                this.langs = response.data.data;
              }
            }
          )
          .catch(function(e){})
    },
  },
  mounted(){
    this.fetch();
    if(Cookies.get('lang')){
      this.$store.commit('set_lang',Cookies.get('lang'));
    }
  },
}
</script>

<style scoped>

</style>
